<div class="image-picker__wrapper">
	<div
		class="image-picker__button"
		[ngClass]="{'display--none': !src}"
		[tooltip]="deleteImageTooltip"
		(click)="onClearButton()">
		<skl-icon name="cross"></skl-icon>
	</div>
	<skl-image
		(click)="pickImage()"
		[ratio]="ratio"
		[width]="100"
		[unit]="'%'"
		[src]="src!">
	</skl-image>
	<skl-filepicker-ins
		#filepicker
		class="image-picker__file-name"
		[maxSize]="maxSize"
		[accept]="accept"
		[fileName]="srcName!"
		[placeholder]="placeholder"
		[unit]="unit"
		(onPick)="onFilePick($event)"
		(onClear)="onFileClear()">
	</skl-filepicker-ins>
</div>